(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apex-size-calculator"] && !Shopify.designMode) return;
  try {
    
function apexParseSize(value) {
  const text = String(value).trim().toUpperCase();
  const metric = text.match(/^(P|LT)?\s*(\d{3})\s*\/\s*(\d{2})\s*(?:ZR|R)\s*(\d{2})$/);
  if (metric) {
    const [, prefix = '', w, a, r] = metric;
    const width = Number(w), aspect = Number(a), wheel = Number(r);
    if (width < 125 || width > 445 || aspect < 20 || aspect > 95 || wheel < 13 || wheel > 30) return null;
    return { format:'metric', prefix, width, aspect, wheel, label:`${prefix}${width}/${aspect}R${wheel}` };
  }
  const standard = text.match(/^(LT)?\s*(\d{2}(?:\.\d{1,2})?)\s*[X×]\s*(\d{1,2}(?:\.\d{1,2})?)\s*R\s*(\d{2})\s*(LT)?$/);
  if (!standard) return null;
  const [, before = '', d, w, r, after = ''] = standard;
  const diameterIn = Number(d), widthIn = Number(w), wheel = Number(r);
  if ((before && after) || diameterIn < 20 || diameterIn > 50 || widthIn < 5 || widthIn > 20 || wheel < 13 || wheel > 30 || diameterIn <= wheel) return null;
  const prefix = before || after;
  return { format:'standard', prefix, width:widthIn*25.4, widthIn, diameterIn, wheel, label:`${diameterIn}x${widthIn.toFixed(2)}R${wheel}${prefix}` };
}
function apexMetrics(size) {
  if (size.format === 'standard') {
    const diameter = size.diameterIn * 25.4;
    return {sidewall:(size.diameterIn-size.wheel)*25.4/2,diameter,circumference:Math.PI*diameter};
  }
  const sidewall = size.width * size.aspect / 100;
  const diameter = size.wheel * 25.4 + 2 * sidewall;
  return {sidewall,diameter,circumference:Math.PI*diameter};
}
function apexDifference(base, candidate) { return (apexMetrics(candidate).diameter / apexMetrics(base).diameter - 1) * 100; }
function apexWithin(value, tolerance) { return Math.abs(value) <= tolerance + 1e-9; }
function apexCandidates(base, options) {
  if (!base || !Number.isFinite(options.tolerance) || options.tolerance < 0 || options.tolerance > 5 || ![0,20,40].includes(options.widthRange) || !['specific','larger','smaller'].includes(options.mode)) return [];
  if (options.mode === 'specific' && (!Number.isInteger(options.target) || options.target < 13 || options.target > 30)) return [];
  const requestedFormat = options.format || 'same';
  if (!['same','metric','standard'].includes(requestedFormat)) return [];
  const format = requestedFormat === 'same' ? (base.format || 'metric') : requestedFormat;
  const candidates = [], seen = new Set(), baseDiameter = apexMetrics(base).diameter;
  const add = candidate => {
    if (!candidate || Math.abs(candidate.width-base.width) > options.widthRange+1e-9) return;
    const diameter = apexMetrics(candidate).diameter;
    if (candidate.wheel === base.wheel && Math.abs(candidate.width-base.width)<1e-9 && Math.abs(diameter-baseDiameter)<1e-9) return;
    const key = `${candidate.width.toFixed(6)}|${candidate.wheel}|${diameter.toFixed(6)}`;
    if (seen.has(key)) return;
    candidate.difference = apexDifference(base,candidate);
    if (!apexWithin(candidate.difference,options.tolerance)) return;
    seen.add(key); candidates.push(candidate);
  };
  for (let wheel=13;wheel<=30;wheel+=1) {
    if (options.mode==='specific' && wheel!==options.target) continue;
    if (options.mode==='larger' && wheel<=base.wheel) continue;
    if (options.mode==='smaller' && wheel>=base.wheel) continue;
    if (format==='metric') {
      const widths=[];
      if ((base.format || 'metric')==='metric') {
        for (let width=base.width-options.widthRange;width<=base.width+options.widthRange;width+=10) widths.push(width);
      } else {
        for (let width=125;width<=445;width+=10) widths.push(width);
      }
      for (const width of widths) {
        if (width<125 || width>445) continue;
        for (let aspect=25;aspect<=85;aspect+=5) add(apexParseSize(`${base.prefix}${width}/${aspect}R${wheel}`));
      }
    } else {
      const widths = new Set(), diameters = new Set();
      for (let width=5;width<=20;width+=.5) widths.add(width);
      for (let diameter=20;diameter<=50;diameter+=.5) diameters.add(diameter);
      if (base.format==='standard') {widths.add(base.widthIn);diameters.add(base.diameterIn);}
      for (const width of widths) {
        if (Math.abs(width*25.4-base.width)>options.widthRange+1e-9) continue;
        for (const diameter of diameters) {
          if (diameter<=wheel) continue;
          add(apexParseSize(`${diameter}x${width.toFixed(2)}R${wheel}${base.prefix==='LT'?'LT':''}`));
        }
      }
    }
  }
  return candidates.sort((a,b)=>Math.abs(a.difference)-Math.abs(b.difference)||Math.abs(a.width-base.width)-Math.abs(b.width-base.width)||a.wheel-b.wheel||a.width-b.width||apexMetrics(a).diameter-apexMetrics(b).diameter||a.label.localeCompare(b.label));
}
if (!customElements.get('apex-size-calculator')) customElements.define('apex-size-calculator', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
    this.$ = selector => this.querySelector(selector);
    this.field = name => this.$(`[data-field="${name}"]`);
    const on = (element, event, callback) => element.addEventListener(event, callback, {signal:this.controller.signal});
    on(this.$('[data-find]'), 'submit', event => { event.preventDefault(); this.findCandidates(); });
    on(this.$('[data-compare]'), 'submit', event => { event.preventDefault(); this.compareManual(); });
    on(this.$('[data-rows]'), 'click', event => {
      const button = event.target.closest('button[data-size]');
      if (!button) return;
      this.field('compare_size').value = button.dataset.size;
      this.compareManual();
    });
    for (const input of this.querySelectorAll('input, select')) on(input, 'input', () => {
      this.$('[data-error]').hidden = true;
      this.$('[data-status]').textContent = this.labels.stale;
      this.$('[data-candidates]').hidden = true;
      this.$('[data-comparison]').hidden = true;
      this.field('target').disabled = this.field('mode').value !== 'specific';
      this.$('[data-tolerance-warning]').hidden = Number(this.field('tolerance').value) <= 3;
    });
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  text(key, replacements = {}) {
    return Object.entries(replacements).reduce((text, [key, value]) => text.replaceAll(`{${key}}`, String(value)), this.labels[key]);
  }
  number(value, digits = 2) { return Number(value.toFixed(digits)).toLocaleString(document.documentElement.lang || 'en', {minimumFractionDigits:digits, maximumFractionDigits:digits}); }
  signed(value) { const rounded = Number(value.toFixed(2)); return `${rounded > 0 ? '+' : ''}${this.number(rounded)}%`; }
  dimension(mm) { return `${this.number(mm / 25.4)} ${this.labels.in} / ${this.number(mm,1)} ${this.labels.mm}`; }
  sectionWidth(mm) { const digits = Math.abs(mm-Math.round(mm))<1e-9 ? 0 : Math.abs(mm*10-Math.round(mm*10))<1e-9 ? 1 : 2; return `${this.number(mm,digits)} ${this.labels.mm} / ${this.number(mm / 25.4)} ${this.labels.in}`; }
  fail(key, field) {
    this.$('[data-error]').textContent = this.labels[key];
    this.$('[data-error]').hidden = false;
    this.$('[data-status]').textContent = '';
    this.$('[data-candidates]').hidden = true;
    this.$('[data-comparison]').hidden = true;
    this.field(field).setAttribute('aria-invalid','true');
    this.field(field).focus();
    return null;
  }
  inputValues() {
    for (const input of this.querySelectorAll('[aria-invalid]')) input.removeAttribute('aria-invalid');
    this.$('[data-error]').hidden = true;
    const base = apexParseSize(this.field('baseline').value);
    if (!base) return this.fail('invalid_size','baseline');
    const rawTolerance = this.field('tolerance').value.trim();
    const tolerance = Number(rawTolerance);
    if (rawTolerance === '' || !Number.isFinite(tolerance) || tolerance < 0 || tolerance > 5) return this.fail('invalid_tolerance','tolerance');
    return {base, tolerance};
  }
  findCandidates() {
    const values = this.inputValues();
    if (!values) return;
    const mode = this.field('mode').value;
    const target = Number(this.field('target').value);
    if (mode === 'specific' && (!Number.isInteger(target) || target < 13 || target > 30)) return this.fail('invalid_wheel','target');
    const candidates = apexCandidates(values.base, {mode,target,tolerance:values.tolerance,widthRange:Number(this.field('width').value),format:this.field('candidate_format').value});
    const shown = candidates.slice(0, 20);
    this.$('[data-rows]').replaceChildren();
    for (const candidate of shown) {
      const tr = document.createElement('tr');
      for (const value of [candidate.label, candidate.wheel, this.sectionWidth(candidate.width), this.dimension(apexMetrics(candidate).diameter), this.signed(candidate.difference)]) {
        const td = document.createElement('td'); td.textContent = value; tr.append(td);
      }
      const td = document.createElement('td'), button = document.createElement('button');
      button.type = 'button'; button.dataset.size = candidate.label; button.className = 'apex-size__choose'; button.textContent = this.labels.choose;
      button.setAttribute('aria-label',this.text('choose_label',{size:candidate.label}));
      td.append(button); tr.append(td); this.$('[data-rows]').append(tr);
    }
    this.$('[data-summary]').textContent = this.text('candidate_summary',{count:candidates.length,shown:shown.length,tolerance:values.tolerance,base:values.base.label});
    this.$('[data-empty]').hidden = candidates.length > 0;
    this.$('[data-candidates] .apex-size__table-wrap').hidden = candidates.length === 0;
    this.$('[data-candidates]').hidden = false;
    this.$('[data-comparison]').hidden = true;
    this.$('[data-status]').textContent = this.text('generate_status',{count:candidates.length});
  }
  compareManual() {
    const values = this.inputValues();
    if (!values) return;
    const candidate = apexParseSize(this.field('compare_size').value);
    if (!candidate) return this.fail('invalid_size','compare_size');
    const speed = Number(this.field('speed').value);
    if (!Number.isFinite(speed) || speed <= 0 || speed > 200) return this.fail('invalid_speed','speed');
    const unit = this.labels[this.field('unit').value];
    const baseMetrics = apexMetrics(values.base), candidateMetrics = apexMetrics(candidate);
    const difference = apexDifference(values.base,candidate);
    this.$('[data-base-heading]').textContent = `${this.labels.current}: ${values.base.label}`;
    this.$('[data-compare-heading]').textContent = `${this.labels.alternative}: ${candidate.label}`;
    this.$('[data-comparison-rows]').replaceChildren();
    for (const [label, baseValue, candidateValue] of [
      ['wheel',`${values.base.wheel} ${this.labels.in}`,`${candidate.wheel} ${this.labels.in}`],
      ['section_width',this.sectionWidth(values.base.width),this.sectionWidth(candidate.width)],
      ['diameter',this.dimension(baseMetrics.diameter),this.dimension(candidateMetrics.diameter)],
      ['sidewall',this.dimension(baseMetrics.sidewall),this.dimension(candidateMetrics.sidewall)],
      ['circumference',this.dimension(baseMetrics.circumference),this.dimension(candidateMetrics.circumference)],
      ['difference','0.00%',this.signed(difference)],
      ['speed_actual',`${this.number(speed)} ${unit}`,`${this.number(speed * candidateMetrics.diameter/baseMetrics.diameter)} ${unit}`]
    ]) {
      const tr = document.createElement('tr');
      const th = document.createElement('th'); th.scope='row'; th.textContent=this.labels[label]; tr.append(th);
      for (const text of [baseValue,candidateValue]) {const td=document.createElement('td');td.textContent=text;tr.append(td);}
      this.$('[data-comparison-rows]').append(tr);
    }
    this.$('[data-verdict]').textContent = this.text(apexWithin(difference,values.tolerance)?'within':'outside',{tolerance:values.tolerance});
    this.$('[data-verdict]').classList.toggle('apex-size__warning',!apexWithin(difference,values.tolerance));
    this.$('[data-downsize]').hidden = candidate.wheel >= values.base.wheel;
    this.$('[data-speed-note]').textContent = this.text('speed_note',{speed:this.number(speed),unit});
    this.$('[data-comparison]').hidden = false;
    this.$('[data-status]').textContent = this.text('comparison_status',{base:values.base.label,size:candidate.label});
    for (const button of this.querySelectorAll('button[data-size]')) {
      const selected = button.dataset.size === candidate.label;
      button.textContent = selected ? this.labels.selected : this.labels.choose;
      button.setAttribute('aria-pressed',String(selected));
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
